import { Action } from '@ngrx/store';

export enum DanmuActionTypes {
    DANMU_RESET = 'Danmu Reset',
    DANMU_LIST_REQUIRED = 'Danmu List Required',
    DANMU_LIST_LOADED = 'Danmu List Loaded',
    DANMU_LIST_LOAD_FAILURE = 'Danmu List Load Failure',
    //DANMU_LOAD_BULLET = 'Danmu Load Bullet',
   // DANMU_BULLET_LOADED = 'Danmu Bullet Loaded',
   // DANMU_FIRE = 'Danmu Fire',
  //  DANMU_RELEASE_BARREL = 'Danmu Release Barrel',
    //DANMU_DESTROY_BULLET = 'Danmu Destroy Bullet',
  //  DANMU_BULLET_DESTROYED = 'Danmu Bullet Destroyed',
    DANMU_PAUSE = 'Danmu Pause',
    DANMU_PLAY = 'Danmu Play',
   // DANMU_TIME_UPDATED = 'Danmu Time Updated',
    DANMU_SEND = 'Danmu Send a Danmu',
    DANMU_NEW = 'Danmu Add New Danmu',
    DANMU_SET_CURRENT_TIME = 'Danmu Set Video Current Time',
  //  DANMU_REQUIRE_BARREL = 'Danmu Require Barrel',
  //  DANMU_BULLET_FIRED = 'Danmu Bullet Fired',
    DANMU_ADD_KEYWORD_FILTER = 'Danmu Add Keyword Filter',
    DANMU_REMOVE_KEYWORD_FILTER = 'Danmu Remove Keyword Filter',
    DANMU_ADD_USER_FILTER = 'Danmu Add User Filter',
    DANMU_REMOVE_USER_FILTER = 'Danmu Remove User Filter',
    DANMU_SET_FULL_SCREEN = 'Danmu Set Full Screen',
    DANMU_BLOCK_TOP = 'Danmu Block Top',
    DANMU_BLOCK_BOTTOM = 'Danmu Block Bottom',
    DANMU_BLOCK_LEFT = 'Danmu Block Left',
    DANMU_SET_SPEED = 'Danmu Set Speed',
    DANMU_TOGGLE_DANMU = 'Danmu Toggle Danmu',
    DANMU_SET_FONT_SIZE = 'Danmu Set Font Size',
    DANMU_SET_OPACITY = 'Danmu Set Opacity',
    DANMU_SET_FONT_FAMILY = 'Danmu Set Font Family',
    DANMU_RESET_ALL_BARRELS = 'Danmu Reset All Barrels',
    DANMU_SET_DANMU_KEY = 'Danmu Set Danmu Key',
    DANMU_REMOVE_DANMU = 'Danmu Remove Danmu',
    DANMU_REMOVED = 'Danmu Removed',
    DANMU_SET_OUTPUT_TYPE = 'Danmu Set Output Type',
    DANMU_SET_OUTPUT_COLOR = 'Danmu Set Output Color',
    DANMU_GET_USER_SETTINGS = 'Danmu Get User Settings',
    DANMU_GET_USER_SETTINGS_SUCCESS = 'Danmu Get User Settings Success',
    DANMU_UPDATE_USER_SETTINGS = 'Danmu Update User Settings',
}

export class DanmuResetAction implements Action {
    type = DanmuActionTypes.DANMU_RESET;
    constructor(public payload: any) { }
}
export class DanmuListRequiredAction implements Action {
    type = DanmuActionTypes.DANMU_LIST_REQUIRED;
    constructor(public payload: { page: number }) { }
}

export class DanmuListLoadedAction implements Action {
    type = DanmuActionTypes.DANMU_LIST_LOADED;
    constructor(public payload: any) { }
}

export class DanmuListLoadFailureAction implements Action {
    type = DanmuActionTypes.DANMU_LIST_LOAD_FAILURE;
    constructor(public payload: any) { }
}

// export class DanmuLoadBulletAction implements Action {
//     type = DanmuActionTypes.DANMU_LOAD_BULLET;
//     constructor(public payload: any) { }
// }

// export class DanmuBulletLoadedAction implements Action {
//     type = DanmuActionTypes.DANMU_BULLET_LOADED;
//     constructor(public payload: { bullet: any }) { }
// }

// export class DanmuFireAction implements Action {
//     type = DanmuActionTypes.DANMU_FIRE;
//     constructor(public payload: { barrel: any, bullet: any }) { }
// }

// export class DanmuReleaseBarrelAction implements Action {
//     type = DanmuActionTypes.DANMU_RELEASE_BARREL;
//     constructor(public payload: any) { }
// }

// export class DanmuDestroyBulletAction implements Action {
//     type = DanmuActionTypes.DANMU_DESTROY_BULLET;
//     constructor(public payload: any) { }
// }

// export class DanmuBulletDestroyedAction implements Action {
//     type = DanmuActionTypes.DANMU_BULLET_DESTROYED;
//     constructor(public payload: any) { }
// }

export class DanmuPauseAction implements Action {
    type = DanmuActionTypes.DANMU_PAUSE;
    constructor(public payload: any) { }
}

export class DanmuPlayAction implements Action {
    type = DanmuActionTypes.DANMU_PLAY;
    constructor(public payload: any) { }
}

// export class DanmuTimeUpdatedAction implements Action {
//     type = DanmuActionTypes.DANMU_TIME_UPDATED;
//     constructor(public payload: any) { }
// }

export class DanmuSendAction implements Action {
    type = DanmuActionTypes.DANMU_SEND;
    constructor(public payload: any) { }
}

export class DanmuNewAction implements Action {
    type = DanmuActionTypes.DANMU_NEW;
    constructor(public payload: any) { }
}

export class DanmuSetCurrentTimeAction implements Action {
    type = DanmuActionTypes.DANMU_SET_CURRENT_TIME;
    constructor(public payload: any) { }
}
// export class DanmuRequirBarrelAction implements Action {
//     type = DanmuActionTypes.DANMU_REQUIRE_BARREL;
//     constructor(public payload: any) { }
// }
// export class DanmuBulletFiredAction implements Action {
//     type = DanmuActionTypes.DANMU_BULLET_FIRED;
//     constructor(public payload: any) { }
// }

export class DanmuAddKeywordFilterAction implements Action {
    type = DanmuActionTypes.DANMU_ADD_KEYWORD_FILTER;
    constructor(public payload: any) { }
}
export class DanmuRemoveKeywordFilterAction implements Action {
    type = DanmuActionTypes.DANMU_REMOVE_KEYWORD_FILTER;
    constructor(public payload: any) { }
}
export class DanmuAddUserFilterAction implements Action {
    type = DanmuActionTypes.DANMU_ADD_USER_FILTER;
    constructor(public payload: any) { }
}
export class DanmuRemoveUserFilterAction implements Action {
    type = DanmuActionTypes.DANMU_REMOVE_USER_FILTER;
    constructor(public payload: any) { }
}
export class DanmuSetFullScreenAction implements Action {
    type = DanmuActionTypes.DANMU_SET_FULL_SCREEN;
    constructor(public payload: any) { }
}
export class DanmuBlockTopAction implements Action {
    type = DanmuActionTypes.DANMU_BLOCK_TOP;
    constructor(public payload: any) { }
}
export class DanmuBlockBottomAction implements Action {
    type = DanmuActionTypes.DANMU_BLOCK_BOTTOM;
    constructor(public payload: any) { }
}
export class DanmuBlockLeftAction implements Action {
    type = DanmuActionTypes.DANMU_BLOCK_LEFT;
    constructor(public payload: any) { }
}
export class DanmuSetSpeed implements Action {
    type = DanmuActionTypes.DANMU_SET_SPEED;
    constructor(public payload: any) { }
}
export class DanmuToggleDanmu implements Action {
    type = DanmuActionTypes.DANMU_TOGGLE_DANMU;
    constructor(public payload: any) { }
}
export class DanmuSetFontSize implements Action {
    type = DanmuActionTypes.DANMU_SET_FONT_SIZE;
    constructor(public payload: any) { }
}
export class DanmuSetOpacity implements Action {
    type = DanmuActionTypes.DANMU_SET_OPACITY;
    constructor(public payload: any) { }
}
export class DanmuSetFontFamily implements Action {
    type = DanmuActionTypes.DANMU_SET_FONT_FAMILY;
    constructor(public payload: any) { }
}
// export class DanmuResetAllBarrels implements Action {
//     type = DanmuActionTypes.DANMU_RESET_ALL_BARRELS;
//     constructor(public payload: any) { }
// }

export class DanmuSetDanmuKeyAction implements Action {
    type = DanmuActionTypes.DANMU_SET_DANMU_KEY;
    constructor(public payload: any) { }
}
export class DanmuRemoveDanmuAction implements Action {
    type = DanmuActionTypes.DANMU_REMOVE_DANMU;
    constructor(public payload: any) { }
}

export class DanmuRemovedAction implements Action {
    type = DanmuActionTypes.DANMU_REMOVED;
    constructor(public payload: any) { }
}
export class DanmuSetOutputTypeAction implements Action {
    type = DanmuActionTypes.DANMU_SET_OUTPUT_TYPE;
    constructor(public payload: any) { }
}
export class DanmuSetOutputColorAction implements Action {
    type = DanmuActionTypes.DANMU_SET_OUTPUT_COLOR;
    constructor(public payload: any) { }
}
export class DanmuGetUserSettingsAction implements Action {
    type = DanmuActionTypes.DANMU_GET_USER_SETTINGS;
    constructor(public payload: any) { }
}
export class DanmuGetUserSettingsSuccessAction implements Action {
    type = DanmuActionTypes.DANMU_GET_USER_SETTINGS_SUCCESS;
    constructor(public payload: any) { }
}
export class DanmuUpdateUserSettingsAction implements Action {
    type = DanmuActionTypes.DANMU_UPDATE_USER_SETTINGS;
    constructor(public payload: any) { }
}

export type Actions =
    | DanmuResetAction
    | DanmuListRequiredAction
    | DanmuListLoadedAction
    | DanmuListLoadFailureAction
  //  | DanmuLoadBulletAction
  //  | DanmuBulletLoadedAction
   // | DanmuFireAction
   // | DanmuReleaseBarrelAction
  //  | DanmuDestroyBulletAction
   // | DanmuBulletDestroyedAction
    | DanmuPauseAction
    | DanmuPlayAction
  //  | DanmuTimeUpdatedAction
    | DanmuSendAction
    | DanmuNewAction
    | DanmuSetCurrentTimeAction
    //| DanmuBulletFiredAction
    | DanmuAddKeywordFilterAction
    | DanmuAddUserFilterAction
    | DanmuRemoveUserFilterAction
    | DanmuSetFullScreenAction
    | DanmuBlockTopAction
    | DanmuBlockBottomAction
    | DanmuBlockLeftAction
    | DanmuSetSpeed
    | DanmuToggleDanmu
    | DanmuSetFontSize
    | DanmuSetOpacity
    //| DanmuResetAllBarrels
    | DanmuSetDanmuKeyAction
    | DanmuRemoveDanmuAction
    | DanmuRemovedAction
    | DanmuSetOutputTypeAction
    | DanmuSetOutputColorAction
    | DanmuGetUserSettingsAction
    | DanmuGetUserSettingsSuccessAction
    | DanmuUpdateUserSettingsAction
    ;
